import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls:  ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {

   public confirmationForm: FormGroup;      // state of the confirmation form

   // DISPLAY POPUP CONFIRMATION
   public displayPopupConfirmOK: boolean;

   constructor(
      private fb: FormBuilder,
      private auth: AuthService,
      private router: Router
   ) {}

   ngOnInit() {
      this.initForm();
   }

   // initialize the confirm form
   initForm() {
      this.confirmationForm = this.fb.group({
         'username': ['', Validators.required],
         'code': ['', Validators.required]
      });
   }  // end initForm

   onSubmitConfirmation(value: any) {

      const username = value.username;
      const code = value.code;

      // call the confirm method of AuthService, that returns an Observable<any>
      this.auth.confirm(username, code).subscribe(
         data => {
            // alert("CONFERMA OK");
            this.displayPopupConfirmOK = true;
            console.log("Successful confirmation");
         },
         error => {
            alert("CONFIRMATION ERROR");
            console.log("Failed confirmation: error = " + JSON.stringify(error, null, 2));
         }
      );

   }  // end onSubmitConfirmation

   redirectToLogin() {
     this.displayPopupConfirmOK = false;
     this.router.navigate(['/login']);       // go to the login page/component
   } // end redirectToLogin

}  // end ConfirmComponent
